// Custom Tooltip
// 

JLM.MD.Tooltip = function( pos_x, pos_y, message ) {
	
	const INSTANCE = {};
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let tooltip, inner;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// Remove any existing tooltips
		if ( JLM.MD.Tooltip.instance ) {
			JLM.MD.Tooltip.instance.remove();
		}
		
		// Build
		tooltip = $('<div class="tooltip" style="left:' + pos_x + 'px; top: ' + pos_y + 'px;" />').appendTo('body');
		inner = $('<span>' + message + '</span>').appendTo( tooltip );
		
		// Animate reveal
		if ( JLM.MD.Tooltip.is_recent ) {
			tooltip.addClass('reveal_instant');
		} else {
			setTimeout(function() {
				tooltip.addClass('reveal');
			}, 20);
		}
		
		// Save
		JLM.MD.Tooltip.instance = tooltip;
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Update message
	// 
	INSTANCE.update = function( new_message ) {
		inner.html( new_message );
		message = new_message;
	};
	
	
	// Remove
	// 
	INSTANCE.remove = function() {
		// Remove
		tooltip.addClass('conceal');
		setTimeout(function() {
			tooltip.remove();
		}, 500);
		
		// Reset
		JLM.MD.Tooltip.instance = null;
		
		// Timeout
		JLM.MD.Tooltip.is_recent = setTimeout(function() {
			JLM.MD.Tooltip.is_recent = null;
		}, 200);
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};


// Static _______________________________________________________________________

JLM.MD.Tooltip.instance = null;
JLM.MD.Tooltip.is_recent = false;
